import {
  put, takeEvery, call, select,
} from 'redux-saga/effects';

import api from 'src/lib/api';
import getEntityProps from 'src/entities/props';
import { actions as snackbar } from 'src/store/snackbar/slice';
import { actions as entityActions } from 'src/store/entity/slice';

import getResponseErrorMessage from 'src/lib/utils';
import getSnackbarMessage from 'src/lib/snackbar';
import { ENTITY_TYPES, REPAYMENT_TYPES } from 'src/constants';
import { diff } from 'src/lib/helper';
import { actions } from './slice';
import parseRequest from '../../lib/parser/request';

const entityType = ENTITY_TYPES.EXPECTED_INCOME_ENTITY;
const parseRequestData = (data) => parseRequest({ entityType, data });

function* createExpectedIncome({ payload }) {
  const data = parseRequestData(payload);
  try {
    const endpoint = getEntityProps([entityType, 'endpoint']);
    const response = yield call(api.post, endpoint, { data });
    yield put(snackbar.openSuccessSnackbar(`Ожидаемое поступление ${response.id} успешно создано`));
    yield put(entityActions.getListStart(
      { entityType, values: { deal_id: data.deal, type: REPAYMENT_TYPES.income } },
    ));
  } catch (e) {
    const message = getSnackbarMessage({ messageType: 'getListError' });
    yield put(snackbar.openErrorSnackbar(getResponseErrorMessage(e, message)));
  }
}

function* getExpectedIncome({ payload }) {
  const { id } = payload;
  try {
    const endpoint = `${getEntityProps([entityType, 'endpoint'])}${id}/`;
    const response = yield call(api.get, endpoint, {});
    yield put(actions.getExpectedIncomeSuccess({ response }));
  } catch (e) {
    const message = getSnackbarMessage({ messageType: 'getListError' });
    yield put(snackbar.openErrorSnackbar(getResponseErrorMessage(e, message)));
  }
}

function* editExpectedIncome({ payload }) {
  const { id } = payload;
  const data = parseRequestData(payload);
  try {
    const initialValues = yield select((store) =>
      store.expectedIncome.expectedIncome);
    const endpoint = `${getEntityProps([entityType, 'endpoint'])}${id}/`;
    const response = yield call(api.patch, endpoint, {
      data: parseRequestData(diff(initialValues, payload)),
    });
    yield put(actions.editExpectedIncomeSuccess({ response }));
    yield put(snackbar.openSuccessSnackbar(`Поступление ${response.id} успешно обновлено`));
    yield put(entityActions.getListStart(
      { entityType, values: { deal_id: data.deal, type: REPAYMENT_TYPES.income } },
    ));
  } catch (e) {
    const message = getSnackbarMessage({ messageType: 'getListError' });
    yield put(snackbar.openErrorSnackbar(getResponseErrorMessage(e, message)));
  }
}

export default function* sagas() {
  yield takeEvery(actions.createExpectedIncomeStart, createExpectedIncome);
  yield takeEvery(actions.getExpectedIncomeStart, getExpectedIncome);
  yield takeEvery(actions.editExpectedIncomeStart, editExpectedIncome);
}
